<div class="font-bold mb-3" i18n>Please enter the preferred language(s) in the order of priority.</div>
<div class="ml-6">
  <div [ngStyle]="{ visibility: errorFound ? 'visible' : 'hidden' }" class="pt-3" style="color: var(--rs-red)">
    <i class="mr-2 pi pi-times-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="pt-3" style="width: 500px">
    <table width="100%" cellspacing="0" cellpadding="5" border="1">
      <tr style="background: var(--rs-table-header-bg)">
        <th style="width: 6rem; text-align: center"><span class="font-bold" i18n>Entry #</span></th>
        <th style="text-align: center">
          <span class="font-bold" i18n>Preferred Language</span>
        </th>
      </tr>
      <tr>
        <td style="text-align: center">1</td>
        <td>
          <p-select
            styleClass="maximize-inputs"
            [options]="languageSelectionOptions"
            [(ngModel)]="profileValues.languages.language1"
            dataKey="value"
            optionLabel="label"
            i18n-placeholder
            placeholder="Please Select:"
            appendTo="body"
            (onChange)="handleFormEvents()"
            [filter]="true"
          ></p-select>
        </td>
      </tr>
      <tr>
        <td style="text-align: center">2</td>
        <td>
          <p-select
            styleClass="maximize-inputs"
            [options]="languageSelectionOptions"
            [(ngModel)]="profileValues.languages.language2"
            dataKey="value"
            optionLabel="label"
            i18n-placeholder
            placeholder="Please Select:"
            appendTo="body"
            (onChange)="handleFormEvents()"
            [filter]="true"
          ></p-select>
        </td>
      </tr>
      <tr>
        <td style="text-align: center">3</td>
        <td>
          <p-select
            styleClass="maximize-inputs"
            [options]="languageSelectionOptions"
            [(ngModel)]="profileValues.languages.language3"
            dataKey="value"
            optionLabel="label"
            i18n-placeholder
            placeholder="Please Select:"
            appendTo="body"
            (onChange)="handleFormEvents()"
            [filter]="true"
          ></p-select>
        </td>
      </tr>
    </table>
  </div>
</div>
